export default __webpack_public_path__ + "static/media/element_26.355464d7.jpg";